<template src="./registry.html">

</template>

<script>

import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      test: false,
      help: {
        root: Vue.$helpConfig.registry
      }
    }
  },
  created () {
    this.logConsole('Registry created')
  },
  computed: {
    displayOrganizationMenu () {
      return true
    }
  }
}
</script>
